import React from "react";
import { css } from "@emotion/react";
import { FieldLabel } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { Validate } from "react-hook-form";
import { FormErrorMessage, FormTextField } from "@/components/molecules";
import { color } from "@/styles/theme";

type Props = {
  name: string;
  requiredLabel?: boolean;
  hideHelpToolTip?: boolean;
  validate: Validate<any, any> | Record<string, Validate<any, any>>;
  whetherToDisplayTheValidationRule?: boolean;
  whetherToDisplayMailAddressMessage?: boolean;
  labelText?: string;
  disabled?: boolean;
  readOnly?: boolean;
};

export const UsernameFormFieldSrc = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  const idDescriptionText =
    "半角英数字または半角記号「-」「_」「.」で入力してください";
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        {props.requiredLabel ? (
          <FieldLabel
            isRequired
            helpMessage={
              props.hideHelpToolTip
                ? ""
                : "利用者がログインする時に使用するIDです。"
            }
            helpMessagePlacement="bottomLeft"
          >
            ユーザーID
          </FieldLabel>
        ) : (
          <FieldLabel>ユーザーID</FieldLabel>
        )}
      </div>
      <div css={[inputWrapper, props.readOnly && readOnlyWrapper]}>
        <FormTextField
          name={props.name}
          placeholder={""}
          registerOptions={{
            validate: props.validate,
          }}
          ref={ref}
          autoComplete="username"
          disabled={props.disabled}
          readOnly={props.readOnly}
          aria-disabled={props.readOnly || undefined}
          tabIndex={props.readOnly ? -1 : undefined}
        />
        <div css={errorWrapper}>
          <FormErrorMessage name={props.name} />
        </div>
        {props.whetherToDisplayTheValidationRule && (
          <div css={validationRuleText}>
            {props.labelText ? (
              <>
                {idDescriptionText}
                <br />
                {props.labelText}
              </>
            ) : (
              <>{idDescriptionText}</>
            )}
          </div>
        )}
        {props.whetherToDisplayMailAddressMessage && (
          <div css={validationRuleText}>
            管理者の方はメールアドレスでもログインできます。
          </div>
        )}
      </div>
    </div>
  );
};

export const UsernameFormField = React.forwardRef(UsernameFormFieldSrc);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  flex: 1,
});

const readOnlyWrapper = css({
  cursor: "not-allowed",
  input: {
    color: color.boulder,
    backgroundColor: color.lightGray,
    pointerEvents: "none",
  },
});

const errorWrapper = css({
  flex: 1,
});

const validationRuleText = css({
  marginTop: "10px",
  color: "#7E848E",
  fontSize: "12px",
});
